import React from 'react';
import type { LabelSize, LabelProps, LabelComponent } from './interface';
import { BaseTypography } from '../BaseTypography';
import { getTestId } from '@src/utils/testIds';

type LabelValues = {
  [key in LabelSize]: {
    fontSize: number;
    fontWeight: number;
    lineHeight: number;
    letterSpacing: number;
  };
};

const LABEL_VALUES: LabelValues = {
  l: {
    fontSize: 16,
    fontWeight: 610,
    lineHeight: 24,
    letterSpacing: 0,
  },
  m: {
    fontSize: 14,
    fontWeight: 610,
    lineHeight: 20,
    letterSpacing: 0,
  },
  s: {
    fontSize: 13,
    fontWeight: 620,
    lineHeight: 18,
    letterSpacing: 0,
  },
  xs: {
    fontSize: 11,
    fontWeight: 540,
    lineHeight: 16,
    letterSpacing: 0,
  },
};

const Label: LabelComponent = (props: LabelProps) => {
  const { color, textAlign, children } = props;
  const { fontSize, fontWeight, lineHeight, letterSpacing } = LABEL_VALUES[props.size];
  return (
    <BaseTypography
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      letterSpacing={letterSpacing}
      textAlign={textAlign}
      $web={{ component: 'p' }}
      testId={getTestId(props)}
    >
      {children}
    </BaseTypography>
  );
};

export { Label };
